import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';
import { MQ } from '../tools/MQ';

/** Generic flyout helper (e.g. patterns outside site-nav). */
export const create = () => {
	return class extends Controller {
		static values = { init: String };

		connect() {
			useClickOutside(this);
		}

		clickOutside() {
			this.element.classList.remove('is-open');
			this.element.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false');
		}

		open = (e) => {
			var shouldInit = this.initValue ? MQ(this.initValue) : true;

			if (document.querySelector('html').classList.contains('no-hoverevents') && shouldInit) {
				if (!this.element.classList.contains('is-open')) {
					e.preventDefault();
					this.element.classList.add('is-open');
					this.element.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'true');
				}
			}
		};
	};
};
